import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useNetworkScope } from '../../hooks/useNetworkScope'

// Old white-label tool paths under /portal/:brandSlug (pdp-audit, prep-pack,
// proposal(s) — emails, bookmarks, /rmn-tools) land on the pages that
// replaced them (TDC-1499 phase 3). The query string rides along
// (?desireid= / ?dp= product seeds for the wizard).
//
// This used to branch on role, sending brand users slug-free because their
// routers mounted these pages at the root. Since TDC-1609 the portal is
// canonical for clients too and basePath is role-agnostic, so both audiences
// take the same path.
export default function RmnLegacyRedirect({ to }: { to: string }) {
  const { basePath } = useNetworkScope()
  const { search } = useLocation()
  return <Navigate to={{ pathname: `${basePath}${to}`, search }} replace />
}
